export const Kendo = `Kendo`;
export const HighCharts = `HighCharts`;